import { createContext } from 'react';

export const ItemsInputContext = createContext();
